import { IconButton, makeStyles } from "@material-ui/core";

const useStyles = makeStyles(() => ({
  root: {
    color: (props) => props.color,
    width: (props) => props.width,
    height: (props) => props.height,
    backgroundColor: (props) => props.backgroundColor,
    "&:hover": {
      color: (props) => props.hoverColor,
      backgroundColor: (props) => props.hoverBackgroundColor,
    },
    "& svg": {
      fontSize: (props) => props.iconSize,
    },
  },
}));

export const IconButtonMui = ({
  color,
  backgroundColor,
  hoverColor = color,
  hoverBackgroundColor = backgroundColor,
  iconSize,
  width,
  height,
  children,
  ...otherProps
}) => {
  const classes = useStyles({
    color,
    backgroundColor,
    hoverColor,
    hoverBackgroundColor,
    iconSize,
    width,
    height,
  });

  return (
    <IconButton className={classes.root} color="primary" {...otherProps}>
      {children}
    </IconButton>
  );
};
